import {useMemo} from "react";
import {AccountFeature} from "platformed-client/types";
import {q, useQueriesData, useQueryData} from "../state";

// User settings are reachable with no account selected, where
// `whoAmIOnAccount` has no region to address and would throw. No account means
// no features.
export function useAccountFeatures(): Set<AccountFeature> {
  const {account} = useQueryData(q.whoAmI());
  const whoami = useQueriesData({queries: account ? [q.whoAmIOnAccount()] : []})[0];
  return useMemo(() => new Set(whoami?.account?.enabled_features ?? []), [whoami?.account?.enabled_features]);
}
